import { FormInstance } from "antd/es/form";
import React from "react";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IBosekran_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IBosekran_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
}

export class Bosekran_ScreenBase extends React.PureComponent<
  IBosekran_ScreenProps,
  any
> {
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "08a6d7f3-337a-4d87-bf31-ddd051efa797",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("bosekran", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
    }

    KuikaAppManager.calculateAndSetBodyHeight("bosekran", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("bosekran", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
